var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProtection(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12 21a9 9 0 1 1 0-18 9 9 0 0 1 0 18zm2.795-12.135V7.668L13.21 7.5l.166 1.365-.86.132-.164-1.497-1.452.2.1 1.429-.924.102-.066-1.563-1.385.697V9.43l1.484 2.096-.826 4.457s.959.632 3.134.5c2.18-.136 2.904-1.131 2.904-1.131l-1.516-4.291.99-2.195z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProtection);
export default __webpack_public_path__ + "static/media/protection.5d7f4742310a80ca3bc0591574995a53.svg";
export { ForwardRef as ReactComponent };